import type { ProfileViewType, SnsProvider } from '~/types/hml-type'

export default function () {
  const runtimeConfig = useRuntimeConfig()
  const viewType = useState<ProfileViewType>('viewType', () => 'main')
  const isShowProfilePopup = useState('showProfilePopup', () => false)
  const { jwtCookie } = useAuth()

  const top = useState('top', () => 0)
  const left = useState('left', () => 0)

  function showProfilePopup(x: number, y: number) {
    isShowProfilePopup.value = true

    top.value = y
    left.value = x
  }

  function hideProfilePopup() {
    isShowProfilePopup.value = false
  }

  function changeViewType(type: ProfileViewType) {
    viewType.value = type
  }

  async function fetchProfileImages(userIds: number[]) {
    return await useAPI<
      {
        id: number
        url: string
      }[]
    >('/hml/v1/profile-image', {
      method: 'GET',
      query: { userIds },
    })
  }

  async function fetchUsableProfileImages() {
    return await useAPI<{
      builtInImages: {
        id: number
        url: string
      }[]
      userUploadImages: {
        id: number
        url: string
      }[]
    }>('/hml/v1/me/usable-profile-images', {
      method: 'GET',
    })
  }

  async function updateMyProfileImage(imageId: number) {
    const { data } = await useAPI(`/hml/v1/me/profile-image/${imageId}`, {
      method: 'PUT',
    })

    return data
  }

  async function uploadProfileImage(file: File) {
    const formData = new FormData()
    formData.append('file', file)

    const { data } = await useAPI('/hml/v1/me/profile-image', {
      method: 'POST',
      body: formData,
    })

    return data
  }

  async function deleteProfileImage(imageId: number) {
    const { data } = await useAPI(`/hml/v1/me/profile-image/${imageId}`, {
      method: 'DELETE',
    })

    return data
  }

  async function fetchMyIntegratedSnsProviders() {
    return await useAPI<SnsProvider[]>('/hml/v1/me/integrated-sns-providers', {
      method: 'GET',
    })
  }

  return {
    isShowProfilePopup,
    showProfilePopup,
    hideProfilePopup,
    top,
    left,
    viewType,
    changeViewType,
    fetchProfileImages,
    fetchUsableProfileImages,
    updateMyProfileImage,
    uploadProfileImage,
    deleteProfileImage,
    fetchMyIntegratedSnsProviders,
  }
}
